export default __webpack_public_path__ + "static/media/search.d340e614.svg";